import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { SchoolComponent } from './school.component';
import { SchoolDetailComponent } from './school-detail.component';
import { SchoolPopupComponent } from './school-dialog.component';
import { SchoolDeletePopupComponent } from './school-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class SchoolResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const schoolRoute: Routes = [
    {
        path: 'school',
        component: SchoolComponent,
        resolve: {
            'pagingParams': SchoolResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.school.home.title'
        }
    }, {
        path: 'school/:id',
        component: SchoolDetailComponent,
        data: {
            authorities: ['ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' , 'ROLE_ADMIN'],
            pageTitle: 'jYoguiApp.school.home.title'
        }
    }, {
        path: 'school/current',
        component: SchoolDetailComponent,
        data: {
            authorities: ['ROLE_USER', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' , 'ROLE_ADMIN'],
            pageTitle: 'jYoguiApp.school.home.title'
        }
    }
];

export const schoolPopupRoute: Routes = [
    {
        path: 'school-new',
        component: SchoolPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.school.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'school/:id/edit',
        component: SchoolPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.school.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'school/:id/delete',
        component: SchoolDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.school.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school/school.route.ts